import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import { Link } from "react-router-dom";
import withCustomStyles from "./GChip.style";

// Filter chip: grey idle, black selected. Renders a Link when `to` is set,
// otherwise a toggle button (aria-pressed).
const GChip = ({
  classes,
  className,
  selected,
  to,
  onClick,
  icon,
  children
}) => {
  const cls = classnames(
    classes.chip,
    { [classes.selected]: selected },
    className
  );
  const content = (
    <>
      {icon && (
        <span className={classes.icon} aria-hidden="true">
          {icon}
        </span>
      )}
      {children}
    </>
  );

  if (to) {
    return (
      <Link
        to={to}
        onClick={onClick}
        className={cls}
        aria-current={selected ? "page" : undefined}
      >
        {content}
      </Link>
    );
  }
  return (
    <button
      type="button"
      onClick={onClick}
      className={cls}
      aria-pressed={selected}
    >
      {content}
    </button>
  );
};

GChip.propTypes = {
  selected: PropTypes.bool,
  to: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  onClick: PropTypes.func,
  icon: PropTypes.node
};

GChip.defaultProps = { selected: false };

export default withCustomStyles(GChip);

// Horizontal chip row that scrolls on phones.
export const GChipRow = withCustomStyles(
  ({ classes, className, label, children }) => (
    <div
      role="group"
      aria-label={label}
      className={classnames(classes.row, className)}
    >
      {children}
    </div>
  )
);
